import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "../../lib/auth";

type MerchantContextValue = {
  businessType: string | null;
  setBusinessType: (v: string | null) => void;
  isSet: boolean;
};

const MerchantContext = createContext<MerchantContextValue | undefined>(undefined);

export const MerchantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { profile, refreshProfile } = useAuth();
  const [local, setLocal] = useState<string | null>(profile?.business_type ?? null);

  useEffect(() => {
    setLocal(profile?.business_type ?? null);
  }, [profile?.business_type]);

  const setBusinessType = async (v: string | null) => {
    setLocal(v);
    await refreshProfile?.();
  };

  const value = useMemo(
    () => ({ businessType: local, setBusinessType, isSet: !!local }),
    [local]
  );

  return <MerchantContext.Provider value={value}>{children}</MerchantContext.Provider>;
};

export function useMerchant() {
  const ctx = useContext(MerchantContext);
  if (!ctx) throw new Error("useMerchant must be used within MerchantProvider");
  return ctx;
}
